/* eslint-disable */
const LangIdleMonitor = {
	"idleMonitor.warnMessage": [
		"You will be logged out automatically in ${time} seconds.",
		"Bạn sẽ tự động đăng xuất sau ${time} giây.",
	],
	"idleMonitor.sessionExpired": [
		"Your session has expired.",
		"Phiên hoạt động của bạn đã hết hạn.",
	],
}

export default LangIdleMonitor



// WEBPACK FOOTER //
// ./src/resources/modules/LangIdleMonitor.js